<template>
  <div>
    <v-row v-if="model && model.idPatient">
      <!-- Sección de información del paciente -->
      <v-col cols="12" md="12" sm="12">
        <patient-information :model="model" />
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <Patient-consultation-info :model="model" />
      </v-col>
    </v-row>

    <!-- Somatometría -->
     <v-row class="mt-2 mb-2">
      <v-expansion-panels v-model="panelSV">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3>Somatometría</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col cols="12" md="12" sm="12">
              <patient-somatometry :model="model" :suimFlag="suimFlag" />
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-divider></v-divider>
      <div class="separator20-50"></div>
    </v-row>

    <!-- Antecedentes, Nota Médica, etc. -->
    <v-row dense>
      <v-col cols="12" md="12" sm="12" class="mb-5">
        <PersonalAntecedents
          :model="model"
          :isViewDetailsForm="isViewDetailsForm"
        />
      </v-col>

      <v-col>
        <v-expansion-panels multiple class="mb-13">
          <!-- QA-17 => ESCALA FINDRISC -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row dense class="text-left">
                <v-col cols="12">
                  <v-banner
                    color="blue-grey lighten-5"
                    class="br black--text"
                    shaped
                    single-line
                    dense
                    align="left"
                  >
                    <v-icon class="mr-2">mdi-chart-donut</v-icon>
                    Escala FINDRISC
                  </v-banner>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <p>
                      Puntuación total:
                      <strong>{{ getCalculatorScore("ETEL-01") }}</strong>
                    </p>
                    <p>
                      Riesgo de desarrollar diabetes en 10 años:
                      <strong>{{
                        getRiskInterpretation("ETEL-01").riskPercentage
                      }}</strong>
                    </p>
                    <p>
                      Interpretación:
                      <strong>{{
                        getRiskInterpretation("ETEL-01").riskInterpretation
                      }}</strong>
                    </p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Puntuación Total</th>
                          <th>
                            Riesgo de desarrollar diabetes en los próximos 10
                            años
                          </th>
                          <th>Interpretación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="range in interpretationRanges"
                          :key="range.min"
                          :class="
                            isScoreInRange('ETEL-03', range.min, range.max)
                          "
                        >
                          <td>
                            {{
                              range.min === 21
                                ? "Más de 20 puntos"
                                : `${range.min} - ${range.max}`
                            }}
                          </td>
                          <td>{{ range.risk }}</td>
                          <td
                            :class="
                              getInterpretationClass(range.interpretation)
                            "
                          >
                            {{ range.interpretation }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- QA-16 => Riesgo Cardiovascular -->
          <v-expansion-panel v-show="getAge(datePatiente) >= 44">
            <v-expansion-panel-header>
              <v-row dense class="text-left">
                <v-col cols="12">
                  <v-banner
                    color="blue-grey lighten-5"
                    class="br black--text"
                    shaped
                    single-line
                    dense
                    align="left"
                  >
                    <v-icon class="mr-2">mdi-heart-pulse</v-icon>
                    Riesgo Cardiovascular
                  </v-banner>
                </v-col>
              </v-row>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-container fluid>
                <v-row align="center" justify="space-around">
                  <v-col cols="12" md="6" class="text-center">
                    <p class="subtitle-1">
                      Porcentaje de Riesgo Cardiovascular:
                    </p>
                    <h1 class="display-1 font-weight-bold">
                      {{ getCalculatorScore("ETEL-02") }}%
                    </h1>
                  </v-col>

                  <v-col cols="12" md="4" class="d-flex justify-center">
                    <v-card outlined class="pa-2 compact-risk-table">
                      <v-card-title
                        class="text-center"
                        style="
                          background-color: #008000;
                          color: #fff;
                          font-size: 0.85rem;
                          padding: 4px;
                        "
                      >
                        Tabla de porcentaje referencial
                      </v-card-title>

                      <v-simple-table>
                        <tbody>
                          <tr>
                            <td class="bg-darkest-red" style="width: 24px"></td>
                            <td>≥ 50 %</td>
                          </tr>
                          <tr>
                            <td class="bg-dark-red"></td>
                            <td>40 – 49 %</td>
                          </tr>
                          <tr>
                            <td class="bg-red"></td>
                            <td>30 – 39 %</td>
                          </tr>
                          <tr>
                            <td class="bg-orange"></td>
                            <td>20 – 29 %</td>
                          </tr>
                          <tr>
                            <td class="bg-yellow"></td>
                            <td>10 – 19 %</td>
                          </tr>
                          <tr>
                            <td class="bg-light-green"></td>
                            <td>5 – 9 %</td>
                          </tr>
                          <tr>
                            <td class="bg-green"></td>
                            <td>&lt; 5 %</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- QA-18 => HIPERPLASIA PROSTATICA -->
          <v-expansion-panel
            v-show="getAge(datePatiente) >= 40 && model.gender === 'H'"
          >
            <v-expansion-panel-header>
              <v-row dense class="text-left">
                <v-col cols="12">
                  <v-banner
                    color="blue-grey lighten-5"
                    class="br black--text"
                    shaped
                    single-line
                    dense
                    align="left"
                  >
                    <v-icon class="mr-2">mdi-diabetes</v-icon>
                    Hiperplasia Prostática
                  </v-banner>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <p>
                      Puntaje total:
                      <strong> {{ getCalculatorScore("ETEL-03") }}</strong>
                    </p>
                    <p>
                      Sintomatología:
                      <strong>
                        {{ getHiperplasiaInterpretation("ETEL-03") }}</strong
                      >
                    </p>
                  </v-col>
                </v-row>

                <!-- Tabla de interpretación estilizada -->
                <v-row>
                  <v-col cols="12">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Puntuación total</th>
                          <th>Sintomatología</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>De 1 a 7 puntos</td>
                          <td class="bg-green">Leve</td>
                        </tr>
                        <tr>
                          <td>De 8 a 19 puntos</td>
                          <td class="bg-yellow">Moderada</td>
                        </tr>
                        <tr>
                          <td>Arriba de 20 puntos</td>
                          <td class="bg-red">Severa</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="12" md="12" sm="12" class="mb-5">
        <h3 align="left">Nota médica:</h3>
        <br />
        <v-row class="mb-5">
          <v-col
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Nota médica"
              rules="required"
            >
              <vue-editor
                v-model="model.content"
                :errors-message="errors"
                required
                :disabled="isViewDetailsForm"
                @input="onEditorInput"
              />
              <span class="error--text">{{ errors.toString() }}</span>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <PatientCIE10Component
          :model="model"
          :saveCie10Changes="saveCie10Changes"
          :isViewDetailsForm="isViewDetailsForm"
          :isUpdate="true"
        />
      </v-col>
    </v-row>

    <!-- Sección para subir archivos -->
    <v-row align="center" justify="center" class="mb-4 mt-4">
      <v-col cols="6">
        <h3 class="font-weight-black mb-5">Adjuntar archivos</h3>
        <v-row align="center" justify="center">
          <v-col cols="8">
            <validation-provider
              v-slot="{ errors }"
              name="Adjuntar archivos"
              rules="maxSizeFile"
            >
              <v-file-input
                v-model="files"
                placeholder="Seleccione los archivos"
                label="Adjuntar archivos (opcional)"
                multiple
                show-size
                counter
                prepend-icon="mdi-paperclip"
                :disabled="isViewDetailsForm"
                :error-messages="errors"
                @change="handleFileChange"
              />
            </validation-provider>
          </v-col>
        </v-row>

        <!-- Vista previa de archivos -->
        <v-row class="d-flex flex-nowrap" align="start" justify="center">
          <v-col
            cols="3"
            class="text-center"
            v-for="(file, index) in model.telemedicineFiles"
            :key="index"
          >
            <!-- Imágenes (png, jpg, jpeg) -->
            <template v-if="isImage(file.fileName)">
              <img
                :src="getImageUrl(file)"
                style="width: 100%; height: auto; border-radius: 8px"
                :alt="file.fileName"
              />
              <h3 style="font-size: 100%; text-align: center">
                {{ file.fileName }}
              </h3>
              <v-btn
                small
                color="primary"
                @click="openImage(file.base64, file.fileName)"
              >
                Ver Imagen
              </v-btn>
            </template>

            <!-- PDF -->
            <template v-else-if="isPdf(file.fileName)">
              <v-icon size="100px" color="red">mdi-file-pdf-box</v-icon>
              <h3 style="font-size: 100%; text-align: center">
                {{ file.fileName }}
              </h3>
              <v-btn
                small
                color="primary"
                @click="openPdf(file.base64, file.fileName)"
              >
                Ver PDF
              </v-btn>
            </template>

            <!-- Word (doc, docx) -->
            <template v-else-if="isWord(file.fileName)">
              <v-icon size="100px" color="blue darken-2"
                >mdi-file-word-box</v-icon
              >
              <h3 style="font-size: 100%; text-align: center">
                {{ file.fileName }}
              </h3>
              <v-btn
                small
                color="primary"
                @click="openWord(file.base64, file.fileName)"
              >
                Ver Word
              </v-btn>
            </template>

            <!-- Otros (no compatibles) -->
            <template v-else>
              <v-icon size="100px" color="grey">mdi-file</v-icon>
              <h3 style="font-size: 100%; text-align: center">
                {{ file.fileName }}
              </h3>
              <h3 style="font-size: 100%; text-align: center">
                Archivo no compatible
              </h3>
            </template>

            <!-- Botón "Eliminar" (solo en modo edición) -->
            <v-btn
              v-if="!isViewDetailsForm"
              small
              color="red"
              class="mt-2"
              @click="removeFile(index)"
            >
              <v-icon>mdi-delete</v-icon> Eliminar
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
import PatientSomatometry from "@/app/components/common/patient/PatientSomatometry.vue";
import PersonalAntecedents from "@/app/components/optometry/common/PersonalAntecedents.vue";
import PatientCIE10Component from "@/app/components/common/patient/PatientCIE10Component.vue";
import CalculatorsSomatometryRequest from "@/core/request/CalculatorsSomatometryRequest";
import { PatientInfoService } from "@/app/services";

import { ValidationProvider } from "vee-validate";
import { VueEditor } from "vue2-editor";

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const result = evt.target.result || "";
      const base64 = result.split(",")[1] || "";
      resolve(base64);
    };
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

export default {
  props: {
    model: Object,
    idMedicalPractice: String,
    saveCie10Changes: Boolean,
    isViewDetailsForm: Boolean,
  },
  components: {
    PatientInformation,
    PatientConsultationInfo,
    PatientSomatometry,
    PersonalAntecedents,
    PatientCIE10Component,
    ValidationProvider,
    VueEditor,
  },
  data() {
    return {
      panelSV: 0,
      suimFlag: 1,
      files: [],
      datePatiente: null,
      calculatorsData: [],
      interpretation: [
        {
          scoreRange: "Menos de 7",
          risk: "Riesgo bajo",
          description: "1%",
          minValue: 0,
          maxValue: 6,
        },
        {
          scoreRange: "7-11",
          risk: "Riesgo ligeramente elevado",
          description: "4%",
          minValue: 7,
          maxValue: 11,
        },
        {
          scoreRange: "12-14",
          risk: "Riesgo moderado",
          description: "17%",
          minValue: 12,
          maxValue: 14,
        },
        {
          scoreRange: "15-20",
          risk: "Riesgo alto",
          description: "33%",
          minValue: 15,
          maxValue: 20,
        },
        {
          scoreRange: "Más de 20",
          risk: "Riesgo muy alto",
          description: "50%",
          minValue: 21,
          maxValue: 99,
        },
      ],
      headersDiabetesResults: [
        {
          text: "Puntuación total",
          align: "start",
          value: "scoreRange",
        },
        {
          text: "Riesgo de desarrollar diabetes en los próximos 10 años",
          value: "description",
        },
        { text: "Interpretación", value: "risk" },
      ],
      interpretationRanges: [
        { min: 0, max: 6, risk: "1%", interpretation: "Riesgo bajo" },
        {
          min: 7,
          max: 11,
          risk: "4%",
          interpretation: "Riesgo ligeramente elevado",
        },
        { min: 12, max: 14, risk: "17%", interpretation: "Riesgo moderado" },
        { min: 15, max: 20, risk: "33%", interpretation: "Riesgo alto" },
        { min: 21, max: 99, risk: "50%", interpretation: "Riesgo muy alto" },
      ],
    };
  },

  mounted() {
    const stored = localStorage.getItem("calculatorsData");
    if (stored) {
      this.calculatorsData = JSON.parse(stored);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("calculatorsData");
  },

  created() {
    if (!this.model.telemedicineFiles) {
      this.$set(this.model, "telemedicineFiles", []);
    }
    this.getDataConsulty();
  },
  methods: {
    deleteFile(fileName) {
      const index = this.files.findIndex((file) => file.name === fileName);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },
    handleFileChange(newFiles) {
  if (!this.model.telemedicineFiles) {
    this.$set(this.model, "telemedicineFiles", []);
  }

  const maxSize = 10 * 1024 * 1024; 

  for (const file of newFiles) {
    if (file.size > maxSize) {
      this.$toast && this.$toast.error("El archivo excede el límite permitido (10MB)");
      continue; 
    }
    
    const exists = this.model.telemedicineFiles.some(
      (f) => f.fileName === file.name
    );
    if (!exists) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.model.telemedicineFiles.push({
          fileName: file.name,
          base64: event.target.result.split(",")[1],
          filePath: "",
        });
      };
      reader.readAsDataURL(file);
    }
  }
},
    removeFile(index) {
      if (
        this.model.telemedicineFiles &&
        this.model.telemedicineFiles.length > 0
      ) {
        this.model.telemedicineFiles.splice(index, 1);
      }
    },

    isImage(fileName) {
      const validExtensions = ["png", "jpg", "jpeg"];
      const fileExtension = fileName.split(".").pop().toLowerCase();
      return validExtensions.includes(fileExtension);
    },

    isPdf(fileName) {
      return fileName.split(".").pop().toLowerCase() === "pdf";
    },

    isWord(fileName) {
      const validExtensions = ["doc", "docx"];
      const fileExtension = fileName.split(".").pop().toLowerCase();
      return validExtensions.includes(fileExtension);
    },

    getImageUrl(file) {
      if (file.base64) {
        return "data:image/png;base64," + file.base64;
      }
      return file.url || "";
    },

    openImage(base64, fileName) {
      if (!base64) return;
      const ext = fileName.split(".").pop().toLowerCase();
      let mimeType = "image/png";
      if (ext === "jpg" || ext === "jpeg") {
        mimeType = "image/jpeg";
      }
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    },

    openPdf(base64, fileName) {
      const byteCharacters = atob(base64);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    },

    openWord(base64, fileName) {
      const fileExtension = fileName.split(".").pop().toLowerCase();
      let mimeType = "application/octet-stream"; // fallback
      if (fileExtension === "doc") {
        mimeType = "application/msword";
      } else if (fileExtension === "docx") {
        mimeType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      }
      const byteCharacters = atob(base64);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    },
    getFileIconAndColor(file) {
      const fileType = file.type;
      const fileName = file.name.toLowerCase();

      if (fileType.includes("pdf")) {
        return { icon: "mdi-file-pdf-box", color: "error" };
      }

      if (
        fileType.includes("msword") ||
        fileType.includes("wordprocessingml.document") ||
        fileName.endsWith(".doc") ||
        fileName.endsWith(".docx")
      ) {
        return { icon: "mdi-file-word-box", color: "blue darken-2" };
      }

      if (
        fileType.includes("excel") ||
        fileType.includes("spreadsheetml.sheet") ||
        fileName.endsWith(".xls") ||
        fileName.endsWith(".xlsx")
      ) {
        return { icon: "mdi-file-excel-box", color: "green darken-2" };
      }

      if (
        fileType.startsWith("image/") ||
        fileName.endsWith(".jpg") ||
        fileName.endsWith(".jpeg") ||
        fileName.endsWith(".png")
      ) {
        return { icon: "mdi-image", color: "secondary" };
      }

      return { icon: "mdi-file", color: "grey" };
    },
    loadCalculators() {
      if (!this.model) return;

      const payload = {
        evaluationTypes: [9, 10, 11],
        idPerson: this.model.idPerson,
        idClinicalEvent: this.model.idClinicalEvent || null,
      };

      CalculatorsSomatometryRequest.getCalculatorsSomatometry(payload)
        .then((res) => {
          this.calculatorsData = res.data;
        })
        .catch((err) => {
          console.error(
            "Error al cargar calculadoras en la vista detalle:",
            err
          );
        });
    },

    findCalculatorById(idCalc) {
      return (this.calculatorsData || []).find(
        (calc) => calc.idCalculator === idCalc
      );
    },

    getCalculatorScore(idCalc) {
      const calculator = this.findCalculatorById(idCalc);
      return calculator ? parseInt(calculator.score, 10) || 0 : 0;
    },

    getAge(birthDateMillis) {
      if (!birthDateMillis) return 0;
      const now = new Date();
      const birthDate = new Date(birthDateMillis);

      let age = now.getFullYear() - birthDate.getFullYear();
      const monthDiff = now.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && now.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },

    getHiperplasiaInterpretation() {
      const calculator = this.findCalculatorById("ETEL-03");
      if (!calculator) return "N/A";

      const total = parseInt(calculator.score, 10) || 0;
      if (total <= 7) {
        return "Leve";
      } else if (total <= 19) {
        return "Moderada";
      } else {
        return "Severa";
      }
    },
    getDataConsulty() {
      
      let idPatient = this.model.idPatient;
      let params = { idPatient: idPatient };
      PatientInfoService.getBasicInformation(params).then((res) => {
        if (res.status === 200) {
          this.datePatiente = res.data.person.birthDate
        } 
      });
    },

    getRiskInterpretation(idCalc) {
      const calculator = this.findCalculatorById(idCalc);
      if (!calculator)
        return { riskPercentage: "N/A", riskInterpretation: "N/A" };

      const total = parseInt(calculator.score, 10) || 0;
      const foundRange = this.interpretationRanges.find(
        (range) => total >= range.min && total <= range.max
      );
      if (!foundRange) {
        return {
          riskPercentage: "N/A",
          riskInterpretation: "N/A",
        };
      }
      return {
        riskPercentage: foundRange.risk,
        riskInterpretation: foundRange.interpretation,
      };
    },

    getCardioRiskForCalculator(idCalc) {
      const calculator = this.findCalculatorById(idCalc);
      if (!calculator) return 0;
      return 15;
    },

    isScoreInRange(idCalc, min, max) {
      const score = this.getCalculatorScore(idCalc);
      return score >= min && score <= max ? "highlight-row" : "";
    },
    getInterpretationClass(interpretation) {
      switch (interpretation) {
        case "Riesgo bajo":
          return "bg-light-green";
        case "Riesgo ligeramente elevado":
          return "bg-orange";
        case "Riesgo moderado":
          return "bg-orange";
        case "Riesgo alto":
          return "bg-red";
        case "Riesgo muy alto":
          return "bg-red";
        default:
          return "";
      }
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.model.content = ''
      } else {
        this.model.content = html
      }
    },
  },
};
</script>

<style scoped>
.bg-light-green {
  background-color: #4caf50;
  font-weight: bold;
  color: white;
  text-align: center;
}
.bg-green {
  background-color: #008000;
  font-weight: bold;
  color: white;
  text-align: center;
}
.bg-light-green {
  background-color: #8bc34a;
  font-weight: bold;
  color: black;
  text-align: center;
}
.bg-yellow {
  background-color: #ffeb3b;
  font-weight: bold;
  color: black;
  text-align: center;
}
.bg-orange {
  background-color: #ff9800;
  font-weight: bold;
  color: black;
  text-align: center;
}
.bg-red {
  background-color: #f44336;
  font-weight: bold;
  color: black;
  text-align: center;
}
.bg-dark-red {
  background-color: #b71c1c;
  font-weight: bold;
  color: white;
  text-align: center;
}
.bg-darkest-red {
  background-color: #7f0000;
  font-weight: bold;
  color: white;
  text-align: center;
}
.compact-risk-table {
  max-width: 250px; /* Ajusta el ancho para que sea “corto” */
  font-size: 0.85rem; /* Fuente un poco más pequeña */
}

.compact-risk-table .risk-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.compact-risk-table .risk-percentage {
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

/* Hace la tabla más compacta: menos padding y fuente más pequeña */
.compact-risk-table .v-simple-table thead th,
.compact-risk-table .v-simple-table tbody td {
  padding: 4px 8px !important;
  font-size: 0.8rem;
}

/* Reducir el tamaño de los recuadros de color */
.color-box {
  width: 18px;
  height: 18px;
}
</style>

